var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _c(
        "Card",
        {
          staticClass: "filters",
          attrs: { display: "flex", flexAlign: "center" }
        },
        [
          _c(
            "Box",
            { attrs: { marginRight: 3 } },
            [
              _c(
                "UISelect",
                {
                  staticStyle: { width: "220px" },
                  model: {
                    value: _vm.filters.type,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "type", $$v)
                    },
                    expression: "filters.type"
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Select Type")
                  ]),
                  _c(
                    "option",
                    { attrs: { value: "PledgeCreatedAuditLogItem" } },
                    [_vm._v("Creation")]
                  ),
                  _c(
                    "option",
                    { attrs: { value: "PledgeUpdatedAuditLogItem" } },
                    [_vm._v("Update")]
                  ),
                  _c("option", { attrs: { value: "AuditLogGenericItem" } }, [
                    _vm._v("Invoice & Receipt")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "Box",
            { attrs: { marginRight: 3 } },
            [
              _c("UserLookup", {
                attrs: {
                  placeholder: "Filter by user",
                  clearable: "",
                  value: _vm.filters.userId
                },
                on: { input: _vm.onUserChanged }
              })
            ],
            1
          ),
          _c(
            "Box",
            { staticStyle: { width: "220px" } },
            [
              _c("DateRangePicker", {
                model: {
                  value: _vm.filters.daterange,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "daterange", $$v)
                  },
                  expression: "filters.daterange"
                }
              })
            ],
            1
          ),
          _c(
            "Box",
            {
              staticClass: "clear",
              on: {
                click: function($event) {
                  return _vm.clearFilters()
                }
              }
            },
            [_vm._v("Clear Filters")]
          )
        ],
        1
      ),
      _c("Card", { staticClass: "audit" }, [
        _c(
          "ul",
          { staticClass: "timeline" },
          [
            _vm._l(_vm.filteredLog, function(item, index) {
              return [
                _c(
                  "li",
                  { key: index, staticClass: "item" },
                  [
                    item.type === "PledgeCreatedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Pledge Created")]
                        )
                      : _vm._e(),
                    item.type === "PledgeUpdatedAuditLogItem"
                      ? _c(
                          "Box",
                          [
                            _c(
                              "layoutText",
                              {
                                attrs: {
                                  fontSize: 1,
                                  color: "#666",
                                  fontWeight: "semibold"
                                }
                              },
                              [_vm._v("Pledge Updated")]
                            ),
                            _c("PledgeUpdateAuditItem", {
                              attrs: { item: item }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "FundraiserAssignedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Fundraiser Assigned")]
                        )
                      : _vm._e(),
                    item.type === "FundraiserRemovedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Fundraiser Removed")]
                        )
                      : _vm._e(),
                    item.type === "PaymentAppliedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Payment Applied")]
                        )
                      : _vm._e(),
                    item.type === "PaymentApplicationRemovedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Payment Removed")]
                        )
                      : _vm._e(),
                    item.type === "PaymentApplicationUpdatedAuditLogItem"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Payment Updated")]
                        )
                      : _vm._e(),
                    item.type === "AuditLogGenericItem" &&
                    item.eventType === "payments-invoiceSent"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Invoice Sent")]
                        )
                      : _vm._e(),
                    item.type === "AuditLogGenericItem" &&
                    item.eventType === "payments-receiptSent"
                      ? _c(
                          "layoutText",
                          {
                            attrs: {
                              fontSize: 1,
                              color: "#666",
                              fontWeight: "semibold"
                            }
                          },
                          [_vm._v("Receipt Sent")]
                        )
                      : _vm._e(),
                    _c(
                      "layoutText",
                      {
                        staticClass: "audit-date",
                        attrs: { fontSize: 1, color: "#666" }
                      },
                      [_vm._v(_vm._s(_vm.formatDate(item.date)))]
                    ),
                    _c(
                      "layoutText",
                      { attrs: { fontSize: 2, color: "#333" } },
                      [
                        _c("span", { staticClass: "user" }, [
                          _vm._v(_vm._s(_vm.userName(item)))
                        ]),
                        item.pledgeCreatedData
                          ? _c("span", [
                              _vm._v(
                                "| " + _vm._s(item.pledgeCreatedData.department)
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }